import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    font:{
        fontSize:'18px'
    },
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Uncle= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={6} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
             Hero Head
                <br />
                <Typography component="span" variant="inherit" color="primary">
       Uncle
                </Typography>
              </span>
            }
            subtitle="Cracking stability using a pile of one-trick, protein-hungry tools is a ton of work. Uncle combines 3 different measurement modes — fluorescence, SLS and DLS. So, you can crank out all your data in just a few hours, and use way less protein. All the info you’ll get makes picking the best formulation or protein construct a piece of cake."
            align="left"
            disableGutter
            titleVariant="h3"

            />
           <SectionHeader
             subtitle="Helps you Study"
             align="left"
             disableGutter
             titleVariant="h5"
             />

            <ul className = {classes.font}>
                <li>
                	Tm & Tagg 
                </li>

                <li>
                ΔG 

                </li>
                <li>
            Isothermal stability 
                </li>
                <li>
                Thermal recovery 

                </li>
                <li>
            Sizing & polydispersity 

                </li>

                <li>
                Sizing with thermal ramp 
                </li>

                <li>
            B22 & kD 

                </li>

                <li>
                G22 

                </li>

                <li>
                Viscosity
                </li>


            </ul>

            <SectionHeader
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
                Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
              Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/unchained/uncle_zlvJ5U-8B82.png?updatedAt=1627715332887"
            alt="Uncle"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Uncle.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Uncle;
